export const moduleName = 'teenybeansModule';
